import classNames from "classnames";

import styles from "./UI.module.css";

const VARIANT = {
    h6: { className: styles.h6, tag: "h6" },
    body1: { className: styles.body1, tag: "p" },
    body2: { className: styles.body2, tag: "p" },
};

/**
 * Replaces MUI's <Typography>. Only the three variants this app actually used are
 * implemented; add a class in UI.module.css rather than passing styles inline.
 */
export default function Typography({
    align,
    as,
    children,
    className,
    color,
    variant = "body1",
    ...rest
}) {
    const { className: variantClass, tag } = VARIANT[variant] ?? VARIANT.body1;
    const Component = as ?? tag;

    return (
        <Component
            className={classNames(
                variantClass,
                color === "secondary" && styles.colorSecondary,
                align === "center" && styles.textCenter,
                className,
            )}
            {...rest}
        >
            {children}
        </Component>
    );
}
